import testRepository from "../repositories/TestRepository";

export class TestService {
  static TestApi(instance, id) {
    const repo = new testRepository;
    return repo.testRequest(instance, id).then();
  }
}